<script setup>
import {reactive, onMounted, onUnmounted} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {activeComponentStore} from "@/Stores/ActiveComponentStore";
import {ToastUtil} from "@/Utils/ToastUtil";

const compName = 'MyPayPeriodReleasedComponent';

const props = defineProps({
  contextIdA: String
});

const data = reactive({
  headers: [
    { title: 'Total Fee', key: 'totalfee' },
    { title: 'Admin Fee', key: 'adminfee' },
    { title: 'Client', key: 'client' },
  ],
  items: [],
  isDisabled: false,
  loading: false,
});

const getData = () => {
  ApiWrapper.post('pay-period', 'get-my-marketing-pay-this-period', {payPeriodId: props.contextIdA})
      .then((response) => {
        if(response.marketingpay){
          data.items = response.marketingpay
        }
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.loading = false
        data.isDisabled = false
      })
}

onMounted(()=>{
  getData()
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Marketing Pay</v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        ></v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row>
      </v-row>
      <v-data-table
          :items="data.items"
          :headers="data.headers"
          :search="data.search"
          loading-text="Loading... Please wait"
      >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}
[v-cloak] {
  display: none;
}
</style>